var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM10.1657 9.03431C9.85327 8.7219 9.34673 8.7219 9.03431 9.03431C8.7219 9.34673 8.7219 9.85327 9.03431 10.1657L10.8686 12L9.03431 13.8343C8.7219 14.1467 8.7219 14.6533 9.03431 14.9657C9.34673 15.2781 9.85327 15.2781 10.1657 14.9657L12 13.1314L13.8343 14.9657C14.1467 15.2781 14.6533 15.2781 14.9657 14.9657C15.2781 14.6533 15.2781 14.1467 14.9657 13.8343L13.1314 12L14.9657 10.1657C15.2781 9.85327 15.2781 9.34673 14.9657 9.03431C14.6533 8.7219 14.1467 8.7219 13.8343 9.03431L12 10.8686L10.1657 9.03431Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.245ccd41b6e3df03d16ba1e0c3edafad.svg";
export { ForwardRef as ReactComponent };